(() => {
  const init = () => document.querySelectorAll('.ia-home-journal .ia-journal-grid').forEach((rail) => {
    if (rail.dataset.iaJournalReady) return;
    rail.dataset.iaJournalReady = 'true';
    let startX = 0;
    let startScroll = 0;
    let pointer = null;
    let dragged = false;
    rail.addEventListener('dragstart', (event) => event.preventDefault());
    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointer = event.pointerId;
      dragged = false;
      startX = event.clientX;
      startScroll = rail.scrollLeft;
    });
    rail.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointer) return;
      const distance = event.clientX - startX;
      if (!dragged && Math.abs(distance) < 6) return;
      if (!dragged) { dragged = true; rail.setPointerCapture(pointer); }
      rail.classList.add('ia-journal-dragging');
      rail.scrollLeft = startScroll - distance;
      event.preventDefault();
    });
    const stop = (event) => {
      if (event.pointerId !== pointer) return;
      pointer = null;
      rail.classList.remove('ia-journal-dragging');
      setTimeout(() => { dragged = false; }, 0);
    };
    rail.addEventListener('pointerup', stop);
    rail.addEventListener('pointercancel', stop);
    rail.addEventListener('click', (event) => {
      if (dragged) { event.preventDefault(); event.stopPropagation(); }
    }, true);
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
